<template>
<div class="chapter">
<div class="inner_page">
<h2 title="Title Page"></h2>
<p class="h1" id="toc">Pocket Dictionary of<br/>
  Apologetics &amp;<br/>
  Philosophy of Religion</p>
<p class="h3"> </p>
<p class="h3">C. Stephen Evans</p>
<p class="first"> </p>
<p class="center"><img alt="IVP Books Imprint" src="Images/IVP_Academic_Third.jpg"/></p>
<p> </p>
<p class="center"><a href="http://www.IVPress.com/academic/" target="_blank">www.IVPress.com/academic</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?05121e13